function _newArrowCheck(innerThis, boundThis) {
  if (innerThis !== boundThis) {
    throw new TypeError("Cannot instantiate an arrow function");
  }
}

module.exports = _newArrowCheck;


//////////////////
// WEBPACK FOOTER
// ./~/@babel/runtime/helpers/newArrowCheck.js
// module id = 324
// module chunks = 2